/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Filter_Not_Understood_TitleInputs */

const en_ui_filter_not_understood_title = /** @type {(inputs: Ui_Filter_Not_Understood_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not understood`)
};

const de_ui_filter_not_understood_title = /** @type {(inputs: Ui_Filter_Not_Understood_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht verstanden`)
};

/**
* | output |
* | --- |
* | "Not understood" |
*
* @param {Ui_Filter_Not_Understood_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_not_understood_title = /** @type {((inputs?: Ui_Filter_Not_Understood_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_Not_Understood_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_not_understood_title(inputs)
	return de_ui_filter_not_understood_title(inputs)
});